/**
 * Created by fers on 25.02.16.
 */

import React from 'react';
import PropTypes from 'prop-types';
import {defineMessages, FormattedMessage, IntlShape} from 'react-intl';
import urlMapping from '../app/URLMapping';
import {Link} from 'react-router';
import './channel-defs.scss';
import {safeJSONparse} from "../../common/util/safeJSONparse";

interface ValidationDefinitionResultProps {
    validationResult?: object;
}

const messages = defineMessages({
    validationResult: {
        id: 'validationDefinition.validationResult',
        defaultMessage: 'Validation result:'
    },
    validationResultOk: {
        id: 'channelDef.validationResultOk',
        defaultMessage: 'OK'
    },
    validationError: {
        id: 'validationDefinition.validationError',
        defaultMessage: 'Validation error:'
    },
});

export default class ValidationDefinitionResult extends React.Component<ValidationDefinitionResultProps> {
    static propTypes = {
        validationResult: PropTypes.object,
    };

    renderMessageLabel(str, url) {
        const label = str.msg;
        const labelNode = url ? <Link to={url}>{label}</Link> : <span>{label}</span>;

        if (str.variant === 'heading') {
            return <strong style={{display: 'inline-block', marginTop: '10px', fontSize: '1.2em'}}>{labelNode}</strong>;
        }
        if (str.variant === 'subheading') {
            return <strong>{labelNode}</strong>;
        }

        return labelNode;
    }

    renderMessages() {
        let validationResult = this.props.validationResult;
        let currentUrl = window.location.pathname;

        if (validationResult && validationResult.messages && validationResult.messages.length > 0) {
            return (<ul>
                    {validationResult.messages.map((str, idx) => {
                        let ids = safeJSONparse(str.id);

                        let url = null;
                        if (str.id && str.type) {
                            url = urlMapping.getUrl(str.type, str.action ? str.action : 'view', ids);
                        }

                        if (currentUrl === url) {
                            url = null;
                        }

                        const isHeading = str.variant === 'heading';
                        const isDetail = str.variant === 'detail';
                        const itemStyle = isHeading
                            ? {listStyleType: 'none', marginLeft: '-20px'}
                            : (isDetail ? {marginLeft: '22px', listStyleType: 'circle'} : undefined);

                        return (<li key={idx} style={itemStyle}>
                                {this.renderMessageLabel(str, url)}
                            </li>
                        );
                    })}
                </ul>
            );
        } else {
            return null;
        }

    }

    render() {
        let validationResult = this.props.validationResult;
        if (validationResult) {
            if (validationResult.success) {
                return (
                    <div className="bs-callout bs-callout-success">
                        {validationResult.messages && validationResult.messages.length === 0 ?
                            <p><FormattedMessage {...messages.validationResult}/>
                                {" "}
                                <strong style={{color: 'green'}}>
                                    <FormattedMessage {...messages.validationResultOk}/>
                                </strong>
                            </p>
                        : null}
                        {this.renderMessages()}
                    </div>
                );
            } else {
                return (
                    <div className="bs-callout bs-callout-danger validationResult-error">
                        <p><FormattedMessage {...messages.validationError}/></p>
                        {this.renderMessages()}
                    </div>
                );
            }
        }

        return null;
    }
}
